/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const layout = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M2 2h5v11H2V2zm6 0h5v5H8V2zm6 0h4v16h-4V2zM8 8h5v5H8V8zm-6 6h11v4H2v-4z" />
	</SVG>
);

export default layout;
